exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/_object-pie.js
// module id = 52
// module chunks = 1